// extracted by mini-css-extract-plugin
export var bottomBarContainerV8 = "QIl4y";
export var bottomBarV8 = "jUsfu";
export var chevronContainerV8 = "sCN2m";
export var rootV8 = "bMUAH";
export var tabContentContainerV8 = "Wl8b6";